module.exports = __webpack_public_path__ + "img/item2.7b67a5ee.png";